import  { useState } from "react";
import classNames from "classnames";

import { PillInputBox } from "../../components/forms/form-inputs";
import { AppSwitch } from "../../components/utilities/switcher";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useAuth } from "../../services/authentication/authentication.context";
import { LoadingIndicator } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/app-alert";

export const ResetEmail = () => {

    const [email, setEmail] = useState('');
    const [onAlert, setOnAlert] = useState();

    const {  isLoading } = useAuth();

    const handleSubmit = async(e) => {
        e.preventDefault();
            setOnAlert({
                message: "Email will be sent if you have an account!",
                caption: "Error!",
                accept: "Ok",
                action: () => setOnAlert()
            })
    }

    return (
        <div className={classNames("flx-cnt-pg", "full-v")}>
            {isLoading && <LoadingIndicator />}
            {onAlert &&
            <AppAlert 
                caption={onAlert.caption}
                message={onAlert.message}
                accept={onAlert.accept}
                onAccept={onAlert.action}
                closeAlert={() => setOnAlert()}
            />
            }
            <div className={classNames("cap","lg-txt")}>Send password reset email</div>
            <div className="sm-sp" />
            <form className="sign-in" onSubmit={handleSubmit}>
                <PillInputBox
                    type={"email"}
                    name={"email"}
                    caption={"Email"}
                    placeholder={"e.g mymail@provider.com"}
                    onChange={(e) => setEmail(e.target.value)}
                    required={true}
                />
                <button 
                    className={classNames("form-button",'pill-input-box')}
                >
                    Submit
                </button>

                <div className="alt-actions">
                    <a href="/">Back to home page</a>
                </div>
               
            </form>
        </div>
    )
}